import { useWeb3ModalAccount } from "@web3modal/ethers/react";
// import axios from "axios";
import useSWR from "swr";
import { ethers } from "ethers";
import { useChainInfo } from "./config";

export function useUserInfo() {
    const { address } = useWeb3ModalAccount()
    const { chain } = useChainInfo()
    
    const { data: userInfo, mutate } = useSWR(
      address ? '/info/user' : undefined,
      async () => {
        // const { data } = await axios.get(`${SERVER_URL}/users`, {
        //     params: {
        //         userAddress: address,
        //     },
        // }).catch(() => ({ data: {} }))
        if (chain) {
          const provider = new ethers.JsonRpcProvider(chain.rpcUrl)
          const balance = await provider.getBalance(address as `0x${string}`)
          return {
            balance
          } as any
        }
        return undefined
      }, {
        refreshInterval: 5000,
      }
    )
    return {
        userInfo, setUserInfo: mutate
    }
}